import { render } from "./AccountActivation.vue?vue&type=template&id=484b4949&scoped=true"
import script from "./AccountActivation.vue?vue&type=script&lang=js"
export * from "./AccountActivation.vue?vue&type=script&lang=js"

import "./AccountActivation.vue?vue&type=style&index=0&id=484b4949&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484b4949"]])

export default __exports__